
import { defineComponent, ref, reactive, toRefs, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { Modal } from 'ant-design-vue'

export default defineComponent({
  setup () {

    const store = useStore()
    const current_page = ref(1)

    const fields = ref<any>([
      {
        title: 'Recipient',
        dataIndex: 'recipient',
      },
      {
        title: 'Invoice No.',
        dataIndex: 'invoice_no',
      },
      {
        title: 'Content',
        dataIndex: 'content',
      },
      {
        title: 'Submitted On',
        dataIndex: 'submitted_on',
      },
      {
        title: 'Submitted By',
        dataIndex: 'submitted_by',
      },
      {
        title: 'Account Type',
        dataIndex: 'account_type',
      }
    ])

    const index = (payload = {page: 1}) => {
        payload.page = current_page.value;
        store.dispatch('SMSReport/index', payload)
        .then((res) => {
            console.log(items.value)
            if(current_page.value > res.data.last_page) {
                current_page.value = res.data.last_page
                index()
            }
        })
    }

    const filterRecord = (payload: any) => {
        current_page.value = payload.page;
        index(payload)
    }

    onMounted(() => {
        index()
    })

    const items = computed(() => store.getters['SMSReport/items'])
    const loading = computed(() => store.getters['SMSReport/status'])


    return {
        fields,
        loading,
        items,
        filterRecord
    }
  }

})
